import $ from 'jquery';

export const init = () => {
	const jsAccordion = Array.from(document.querySelectorAll('.js-accordion'));

	function toggleContent() {
		event.stopPropagation();

		const isOpen = $(this).hasClass('is-open');
		const shouldCollapseOthers = $(this).hasClass('just-one');
		if (shouldCollapseOthers && !isOpen) {
			const others = $(this).parent().parent().find('.js-accordion.is-open');
			others.click();
		}

		$(this).parent().find('.accordion__answer').stop().slideToggle();
		$(this).toggleClass('is-open');
		if ($(this).hasClass('is-open')) {
			$(this).attr('aria-expanded', true);
			let dataLayerData = {
				event: 'accordionOpen',
				accordionName: $.trim($(this).text()),
			};
			dataLayer.push(dataLayerData);
		} else {
			$(this).attr('aria-expanded', false);
		}

		if ($(this).hasClass('js-accordion-boilers')) {
			loadBoilerAccordionContent($(this).closest('.accordion'), this.dataset['zipcode']);
		}
	}

	// https://www.w3.org/TR/wai-aria-practices/examples/accordion/accordion.html
	function toggleKeyboardContent() {
		event.stopPropagation();
		const target = event.target;
		const key = event.which.toString();
		// 33 = Page Up, 34 = Page Down
		const ctrlModifier = event.ctrlKey && key.match(/33|34/);
		const altModifier = event.altKey && key.match(/33|34/);

		// Is this coming from an accordion header?
		if (target.classList.contains('js-accordion')) {
			// Up/ Down arrow and Control + Page Up/ Page Down keyboard operations
			// 38 = Up, 40 = Down
			if (key.match(/38|40/) || ctrlModifier || altModifier) {
				const index = jsAccordion.indexOf(target);
				const direction = key.match(/34|40/) ? 1 : -1;
				const length = jsAccordion.length;
				const newIndex = (index + length + direction) % length;

				jsAccordion[newIndex].focus();

				event.preventDefault();
			} else if (key.match(/35|36/)) {
				// 35 = End, 36 = Home keyboard operations
				switch (key) {
					// Go to first accordion
					case '36':
						jsAccordion[0].focus();
						break;
					// Go to last accordion
					case '35':
						jsAccordion[jsAccordion.length - 1].focus();
						break;
				}
				event.preventDefault();
			}
		}
	}

	function loadBoilerAccordionContent(accordion, zipCode) {
		let url = `https://form-service.eon.cz/form-service/service/boilerPriceList/vas_servis_kotlu/PODN/${zipCode}`;

		$.get(url, function (data) {
			let collumnNames = ['Spotřebič', 'Měsíčně bez DPH', 'DPH 21%', 'Cena s DPH', 'Roční cena s DPH'];
			let before = `<table class="js-table"><thead><tr><th>${collumnNames[0]}</th><th>${collumnNames[1]}</th><th>${collumnNames[2]}</th><th>${collumnNames[3]}</th><th>${collumnNames[4]}</th></tr></thead><tbody>`;
			let after = `</tbody></table> `;
			let body = '';
			for (const [_, item] of Object.entries(data.price_list)) {
				let name = item.name;
				let priceVat = item.price;
				let price = priceVat / 1.21;
				let vat = priceVat - price;
				let anualPrice = priceVat * 12;

				body += `<tr>`;
				body += `<td><span class="table-fake-head u-hide@md">${collumnNames[0]}</span>${name}</td >`;
				body += `<td><span class="table-fake-head u-hide@md">${collumnNames[1]}</span>${price.toFixed(2)}&nbsp;Kč</td>`;
				body += `<td><span class="table-fake-head u-hide@md">${collumnNames[2]}</span>${vat.toFixed(2)}&nbsp;Kč</td>`;
				body += `<td><span class="table-fake-head u-hide@md">${collumnNames[3]}</span>${priceVat.toFixed(2)}&nbsp;Kč</td>`;
				body += `<td><span class="table-fake-head u-hide@md">${collumnNames[4]}</span>${anualPrice.toFixed(2)}&nbsp;Kč</td >`;
				body += `</tr>`;
			}

			$(accordion)
				.find('.accordion__answer-text')
				.html(before + body + after);
		});
	}

	$(document).off('click', '.js-accordion').on('click', '.js-accordion', toggleContent);
	$(document).off('keydown', '.js-accordion').on('keydown', '.js-accordion', toggleKeyboardContent);
};
